import { notify } from '@/services/notify/notify';

import type { ApiMetaProps } from './api-meta';
import type { ApiError } from './basic-api-error-validator';

const runHandler = (handler: string | (() => void)): void => {
  if (typeof handler === 'function') {
    handler();
    return;
  }
  notify.alert.error(handler);
};

export const dispatchMetaError = (
  apiError: ApiError,
  meta: ApiMetaProps
): void => {
  const { status, codes } = apiError.response;
  const statusHandlers = meta[status];

  if (!statusHandlers) {
    throw new Error(`Error not handled: ${status} ${codes.join(',')}`);
  }

  for (const code of codes) {
    const handler = statusHandlers[code];
    if (handler !== undefined) {
      runHandler(handler);
      return;
    }
  }

  const wildcardHandler = statusHandlers['*'];
  if (wildcardHandler !== undefined) {
    runHandler(wildcardHandler);
    return;
  }

  throw new Error(`Error not handled: ${status} ${codes.join(',')}`);
};
